import React from "react";
import AnsiUp from "ansi_up";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText, Collapse } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { colors, errorDivStyle } from "./UploadCommon";
/*
{
  "rowIndex": 0,
  "message": "\"date\" must be a number\n\"date\" must be a number of milliseconds or valid date string",
  "annotate": "{\n  \"no\": \"17077\",\n  \"event_pk\": \"341836\",\n  \"replicate_number\": \"1\",\n  \"location\": \"CALVERT\",\n  \"survey\": \"HN_ROCKY_INTERTIDAL\",\n  \"sampling_bout\": \"1\",\n  \"site_id\": \"5BCH_A\",\n  \"depth\": \"0\",\n  \"volume\": \"200\",\n  \"collected\": \"2017-09-19T06:10:05-0700\",\n  \"preserved\": \"2017-09-19T10:10:26-0700\",\n  \"lab_technicians\": \"Tyrel.Froese\",\n  \"filter_no\": \"CHL8113\",\n  \"filter_type\": \"3um\",\n  \"row_flag\": \"Collected\",\n  \"quality_level\": \"Raw\",\n  \"date\" \u001b[31m[1, 2]\u001b[0m: \"Invalid date\"\n}\n\u001b[31m\n[1] \"date\" must be a number\n[2] \"date\" must be a number of milliseconds or valid date string\u001b[0m"
}
*/

// Errors generated by the Joi schema. always errors
const JoiErrors = props => {
  if (!props.rows.length) return <div />;
  const ansiUp = new AnsiUp();
  return (
    <div style={{ ...errorDivStyle, borderColor: colors.error }}>
      <List>
        {props.rows.map((row, i) => [
          <ListItem button onClick={() => props.expand(i)} key={`listItem${i}`}>
            <ListItemText primary={row.message} />
            {props.isExpanded(i) ? <ExpandLess /> : <ExpandMore />}
          </ListItem>,

          <Collapse in={props.isExpanded(i)} key={`collapse${i}`}>
            <List>
              <ListItem>
                <ListItemText
                  primary={
                    <pre style={{ marginLeft: "50px" }}>
                      <span
                        // eslint-disable-next-line
                        dangerouslySetInnerHTML={{
                          __html: ansiUp.ansi_to_html(row.annotate)
                        }}
                      />
                    </pre>
                  }
                />
              </ListItem>
            </List>
          </Collapse>
        ])}
      </List>
    </div>
  );
};
JoiErrors.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object)
};
JoiErrors.defaultProps = {
  rows: []
};
export default JoiErrors;
